import React from 'react'
import { Navigate } from 'react-router-dom'


function ProtectedRoute({ children }) {
    const isAuthenticated = localStorage.getItem('2xgxgshdugyywerw12gh') || ""
    return isAuthenticated ? children : <Navigate to="/login" />;
}
export default ProtectedRoute;